import { useEffect } from 'react';
import { useNetworkStatus } from 'hooks/useNetworkStatus';
import * as Sentry from '@sentry/browser';

const SentryContextHelper = () => {
  const status = useNetworkStatus();

  useEffect(() => {
    Sentry.addBreadcrumb({
      category: 'network',
      message: `Network status: ${status ? 'online' : 'offline'}`,
      level: Sentry.Severity.Info,
    });
  }, [status]);

  return null;
};

export default SentryContextHelper;
